<template>
  <div class="legend pa-2">
    <span class="font-weight-light">LEGEND</span>
    <ul>
      <slot></slot>
    </ul>
  </div>
</template>


<style>
.legend {
  list-style-position: inside;
  list-style-type: circle;
  border: 1px solid;
  margin: auto 1rem !important;
}
</style>

<script>
export default {
  name: "Legend",
  props: {
    title: String,
    reference: String,
    description: String
  }
};
</script>
